import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { FavoritesProvider } from "./context/FavoritesContext";
import Home from "./pages/Home";
import PerfumeDetail from "./pages/PerfumeDetail";
import Wishlist from "./pages/Wishlist";
import AdminOrders from "./pages/AdminOrders";
import "@/App.css";




// 2. COMPONENTE APP
function App() {
  return (
    <div className="App min-h-screen bg-[#FFF5F7]">
      <FavoritesProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/perfume/:id" element={<PerfumeDetail />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </FavoritesProvider>
    </div>
  );
}

// 3. EXPORTACIÓN ÚNICA (Default es para el componente, export const es para la API)
export default App;
